export default {
    computed: {
        insuranceExtras() {
            return this.extras.filter(function(extra) {
                return extra.category == 'Insurance';
            });
        },
    },

    methods: {
        loadVehicleInsuranceOptions(quote) {
            this.$store
                .dispatch('fetchVehicleInsuranceOptions', {
                    quoteId: quote.id,
                    vehicleId: quote.selected_vehicle.data.vehicle.data.id,
                })
                .catch(error => {
                    this.$store.dispatch('createError', error);
                });
        },
    },

    created() {
        let quoteId = this.$route.params.id || this.$route.params.quote_id;

        this.$store.dispatch('fetchExtras', quoteId).catch(error => {
            this.$store.dispatch('createError', error);
        });
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/Insurance.js